/* h2パーツ用のdivを動的に生成
---------------------------------------------- */
export const HEADING_DIV = {
  init: function (elements) {
    $('h2.wp-block-heading, .editor-styles-wrapper h2').wrap('<div class="c-heading__level2-box">')
  },
}
